import React, {useMemo} from "react";
import style from "./style.module.scss";

export const ThirdPartySurveyQuestionRenderer = (
  {
    question,
  }
) => {
    const questionToBeUsed = useMemo(() => {
        return {
            ...question,
            hotspotText: question?.text || {},
        }
    }, [question]);

    return (
        <div className={style.questionContainer}>
            <h3 className={style.questionText}>{questionToBeUsed.hotspotText.text}</h3>
            <div className={style.optionsList}>
                {question.options.map((option, index) => (
                    <div key={option.id} className={style.optionItem}>
                        <input
                            type="radio"
                            id={`option-${index}`}
                            name={`question-${question.id}`}
                            value={option.title.text}
                            className={style.radioInput}
                            readOnly  // keeps the circle styled but not selectable
                        />
                        <label className={style.optionLabel}
                               htmlFor={`option-${index}`}>
                            {option.title.text}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
}
